function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.596,32H7.338C3.292,32,0,28.708,0,24.662V8.404c0-4.046,3.292-7.338,7.338-7.338h7.191c0.884,0,1.6,0.717,1.6,1.601 s-0.716,1.6-1.6,1.6H7.338C5.057,4.267,3.2,6.123,3.2,8.404v16.258c0,2.281,1.856,4.138,4.138,4.138h16.258 c2.281,0,4.138-1.856,4.138-4.138v-7.191c0-0.884,0.716-1.6,1.6-1.6s1.601,0.716,1.601,1.6v7.191C30.934,28.708,27.642,32,23.596,32 z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M32,1.597c0-0.104-0.011-0.208-0.031-0.311c-0.01-0.05-0.028-0.096-0.043-0.144c-0.016-0.051-0.027-0.104-0.048-0.154 c-0.024-0.06-0.058-0.114-0.089-0.169c-0.02-0.035-0.035-0.072-0.058-0.105c-0.117-0.177-0.27-0.328-0.446-0.446 c-0.029-0.02-0.063-0.033-0.094-0.051c-0.059-0.034-0.117-0.069-0.181-0.095c-0.047-0.02-0.097-0.03-0.146-0.045 c-0.051-0.015-0.1-0.035-0.152-0.045c-0.1-0.02-0.201-0.03-0.303-0.03C30.407,0.001,30.403,0,30.4,0H20.8 c-0.884,0-1.6,0.716-1.6,1.6S19.916,3.2,20.8,3.2h5.737l-10.65,10.65c-0.625,0.625-0.625,1.639,0,2.263 c0.313,0.313,0.722,0.469,1.131,0.469s0.818-0.156,1.131-0.469L28.8,5.463V11.2c0,0.884,0.716,1.6,1.601,1.6 c0.884,0,1.6-0.716,1.6-1.6V1.6C32,1.599,32,1.598,32,1.597z"
})));

function SvgIconResizeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResizeUp);
export default __webpack_public_path__ + "static/media/icon-resize-up.226a85db.svg";
export { ForwardRef as ReactComponent };